export default "__VITE_ASSET__CdoSvH_9__"